
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9 15.4a6 6 0 100-12 6 6 0 000 12zm0 1.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z","fill":"#AFAFAF"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9 4.9a.75.75 0 00-.75.75V9.4c0 .414.336.75.75.75h3a.75.75 0 000-1.5H9.75v-3A.75.75 0 009 4.9z","fill":"#AFAFAF"}})])
          )
        }
      }
    